@if (isActive$ | async) {
  <div
    (keydown.escape)="dismiss.emit()"
    aria-modal="true"
    cdkTrapFocus
    cdkTrapFocusAutoCapture
    class="spotlight-dialog"
    role="dialog"
  >
    <canvas #overlayCanvas class="spotlight-canvas" (click)="dismiss.emit()" @fadeIn></canvas>

    <button
      (click)="dismiss.emit()"
      [attr.aria-label]="'COMMON.close' | translate"
      class="spotlight-dismiss"
      type="button"
      data-testid="spotlight-dismiss-button"
    ></button>

    <div class="mascot-layer">
      <recrewt-story-guide
        [desc]="message()"
        [guidePosition]="guidePosition()"
        [anchor]="targetElement()"
        [dismissable]="false"
        [hoverHide]="false"
        (dismiss)="dismiss.emit()"
      />
    </div>
  </div>
}
